import React from "react";

export function NoMatch() {
  return <h2>このページは存在しません。</h2>;
}